module.exports = __webpack_public_path__ + "img/orderb.a2efdcf8.png";